import { useQuery } from '@tanstack/react-query';
import { fetchUnmappedSiteRoad } from '@/shared/apis/unmapped-site-road';
import type {
  UnmappedSitesRoadResponse,
  useUnmappedSiteRoadProps,
} from '@/shared/types/unmapped-site-road';

const useUnmappedSiteRoad = ({ resource = '' }: useUnmappedSiteRoadProps = {}) => {
  const { data: unmappedSiteRoad } = useQuery<UnmappedSitesRoadResponse, Error>({
    queryKey: ['unmappedSiteRoad', resource],
    queryFn: () => fetchUnmappedSiteRoad(resource),
    staleTime: 1000 * 60 * 1,
    // onError: (err) => {
    // },
  });

  return { unmappedSiteRoad };
};

export default useUnmappedSiteRoad;
